import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next";

import { appStore } from "../../stores/appStore";

const Bonus = ({ classList }) => {
    const [selectedBonus, setSelectedBonus] = useState("")

    const { t } = useTranslation("General");

    // getting data from appStore
    const { betSlipSelections, bonusConfig, generalConfig } = appStore((state) => ({
        betSlipSelections: state.betSlipSelections,
        bonusConfig: state.bonusConfig,
        generalConfig: state.generalConfig
    }));

    const onSelectBonus = (array) => {
        switch (array) {
            case 1:
                return setSelectedBonus(
                    <div>{generalConfig.minOddValueForBonus <= 0 ? <span>{t("Add 2 more selections to receive a bonus of")}</span>
                        :
                        <span>{t("Add 2 more selections ( of odds of")} {generalConfig.minOddValueForBonus.toFixed(2)} {t("or higher ) to receive a bonus of")}</span>} {"  "}
                        {bonusConfig.map((bonus) => bonus.selections == 3 && bonus.percentage)}%
                    </div>
                )
            case 2:
                return setSelectedBonus(
                    <div>{generalConfig.minOddValueForBonus <= 0 ? <span>{t("Add 1 more selection to receive a bonus of")}</span>
                        :
                        <span>{t("Add 1 more selection ( of odds of")} {generalConfig.minOddValueForBonus.toFixed(2)} {t("or higher ) to receive a bonus of")}</span>} {"  "}
                        {bonusConfig.map((bonus) => bonus.selections == 3 && bonus.percentage)}%
                    </div>
                )
            case 3:
                return setSelectedBonus(
                    <div>{generalConfig.minOddValueForBonus <= 0 ? <span>{t("Add 1 more selection to receive a bonus of")}</span>
                        :
                        <span>{t("Add 1 more selection ( of odds of")} {generalConfig.minOddValueForBonus.toFixed(2)} {t("or higher ) to receive a bonus of")}</span>} {"  "}
                        {bonusConfig.map((bonus) => bonus.selections == 4 && bonus.percentage)}%
                    </div>
                )
            case 4:
                return setSelectedBonus(
                    <div>{generalConfig.minOddValueForBonus <= 0 ? <span>{t("Add 1 more selection to receive a bonus of")}</span>
                        :
                        <span>{t("Add 1 more selection ( of odds of")} {generalConfig.minOddValueForBonus.toFixed(2)} {t("or higher ) to receive a bonus of")}</span>} {"  "}
                        {bonusConfig.map((bonus) => bonus.selections == 5 && bonus.percentage)}%
                    </div>
                )
            case 5:
                return setSelectedBonus(
                    <div>{generalConfig.minOddValueForBonus <= 0 ? <span>{t("Add 1 more selection to receive a bonus of")}</span>
                        :
                        <span>{t("Add 1 more selection ( of odds of")} {generalConfig.minOddValueForBonus.toFixed(2)} {t("or higher ) to receive a bonus of")}</span>} {"  "}
                        {bonusConfig.map((bonus) => bonus.selections == 6 && bonus.percentage)}%
                    </div>
                )
            case 6:
                return setSelectedBonus(
                    <div>{generalConfig.minOddValueForBonus <= 0 ? <span>{t("Add 1 more selection to receive a bonus of")}</span>
                        :
                        <span>{t("Add 1 more selection ( of odds of")} {generalConfig.minOddValueForBonus.toFixed(2)} {t("or higher ) to receive a bonus of")}</span>} {"  "}
                        {bonusConfig.map((bonus) => bonus.selections == 7 && bonus.percentage)}%
                    </div>
                )
            case 7:
                return setSelectedBonus(
                    <div>{generalConfig.minOddValueForBonus <= 0 ? <span>{t("Add 1 more selection to receive a bonus of")}</span>
                        :
                        <span>{t("Add 1 more selection ( of odds of")} {generalConfig.minOddValueForBonus.toFixed(2)} {t("or higher ) to receive a bonus of")}</span>} {"  "}
                        {bonusConfig.map((bonus) => bonus.selections == 8 && bonus.percentage)}%
                    </div>
                )
            case 8:
                return setSelectedBonus(
                    <div>{generalConfig.minOddValueForBonus <= 0 ? <span>{t("Add 1 more selection to receive a bonus of")}</span>
                        :
                        <span>{t("Add 1 more selection ( of odds of")} {generalConfig.minOddValueForBonus.toFixed(2)} {t("or higher ) to receive a bonus of")}</span>} {"  "}
                        {bonusConfig.map((bonus) => bonus.selections == 9 && bonus.percentage)}%
                    </div>
                )
            case 9:
                return setSelectedBonus(
                    <div>{generalConfig.minOddValueForBonus <= 0 ? <span>{t("Add 1 more selection to receive a bonus of")}</span>
                        :
                        <span>{t("Add 1 more selection ( of odds of")} {generalConfig.minOddValueForBonus.toFixed(2)} {t("or higher ) to receive a bonus of")}</span>} {"  "}
                        {bonusConfig.map((bonus) => bonus.selections == 10 && bonus.percentage)}%
                    </div>
                )
            case 10:
                return setSelectedBonus(
                    <div>{t("Your bonus is")} {" "}
                        {bonusConfig.map((bonus) => bonus.selections == 10 && bonus.percentage)}%
                    </div>
                )
            default:
                return setSelectedBonus(<div>{generalConfig.minOddValueForBonus <= 0 ? <span>{t("Add 3 selections to receive a bonus of")}</span>
                    :
                    <span>{t("Add 3 selections ( of odds of")} {generalConfig.minOddValueForBonus.toFixed(2)} {t("or higher ) to receive a bonus of")}</span>} {"  "}
                    {bonusConfig.map((bonus) => bonus.selections == 3 && bonus.percentage)}%
                </div>
                )
        }
    };

    useEffect(() => {
        let array = 0
        if (!generalConfig || !generalConfig.minOddValueForBonus) {
            generalConfig.minOddValueForBonus = 0
        }
        betSlipSelections.forEach((odds) => {
            if (odds.selectedMarket.selectedOutCome.odds > generalConfig.minOddValueForBonus) {
                array = array + 1
            }
        });
        if (bonusConfig.length > 0) {
            onSelectBonus(array)
        }
    }, [betSlipSelections, bonusConfig]);
    return (
        <React.Fragment>
            {
                bonusConfig.length != 0 &&
                <div>{selectedBonus}</div>
            }
        </React.Fragment>
    )
}
export default Bonus